/**
 * Dollar-value helpers.
 *
 * Clue values changed on 2001-11-26 when the show doubled the board (Jeopardy
 * round went from $100–$500 to $200–$1000; Double Jeopardy from $200–$1000 to
 * $400–$2000). For "authentic board" mode we score using each clue's row
 * position scaled to the MODERN values, so an old $300 first-round clue counts
 * as today's $600.
 */
import type { Clue, Round } from './types';

const DOUBLING_DATE = '2001-11-26'; // ISO compare works lexicographically

/** Row position 1..5 (1 = easiest/top) for a clue, from its board value + era. */
export function rowOf(round: Round, value: number, airDate: string): number {
  if (round === 'FJ' || round === 'TB') return 5;
  const doubled = airDate >= DOUBLING_DATE;
  const step = round === 'J' ? (doubled ? 200 : 100) : doubled ? 400 : 200;
  const row = step ? Math.round(value / step) : 3;
  return Math.max(1, Math.min(5, row));
}

/** Modern board value ($200..$1000 for J, $400..$2000 for DJ). */
export function modernValue(clue: Pick<Clue, 'r' | 'v' | 'd'>): number {
  const row = rowOf(clue.r, clue.v, clue.d);
  return row * (clue.r === 'J' ? 200 : 400);
}
